import { Action, combineReducers } from '@ngrx/store';
import { Shipment } from '../../app/models';
import { objDiff } from '../utility';

import {
  _CLEAR,
  CREATE_OA_SHIPMENT,
  CREATE_SHIPMENT,
  CREATE_ESTIMATES,
  CREATE_PACKAGE_FORM,
  CREATE_YELLOWBAG,
  CREATE_OA_YELLOWBAG,
  DELETE_OA_SHIPMENT,
  DELETE_ORDER,
  DELETE_SHIPMENT,
  DELETE_YELLOWBAG,
  DELETE_OA_YELLOWBAG,
  GET_FORMATTED_SHIPMENTS,
  GET_FORMATTED_YELLOWBAGS,
  GET_SHIPMENT_AMOUNTS,
  GET_OA_SHIPMENTS,
  GET_RTS_TOTALS,
  GET_SHIPMENTS,
  GET_YELLOWBAGS,
  SET_SELECTED_SHIPMENT,
  UPDATE_ESTIMATES,
  UPDATE_PACKAGE_FORM,
  UPDATE_OA_SHIPMENT,
  UPDATE_OA_SHIPMENTS,
  UPDATE_SHIPMENT,
  UPDATE_SHIPMENTS,
  UPDATE_YELLOWBAG,
  UPDATE_OA_YELLOWBAG,
  SET_SHIPMENT_DETAILS_VIEW,
  SET_SHIPMENT_LIST_VIEW
} from '../actions';

const initialShipmentDetailsViewState = {
  addressValidationMsg: <{
    type: string,
    msg: string,
    msgIcon: string,
    suggestions: any[]
  }>{ type: '', msg: '', msgIcon: '', suggestions: [] },
  error                   : <string>'',
  loading                 : <boolean>false,
  jobOnHold               : <boolean>false,
  jobOnHoldAaccessory     : <boolean>false,
  packingSlipPrinting     : <boolean>false,
  shipment                : <Shipment>null,
  shipmentID              : <string>'',
  shipmentLoaded          : <boolean>false,
  shippingEstimates       : <any>[],
  shippingEstimatesLoading: <boolean>false,
  shippingEstimatesMsg    : <string>'',
}

const initialShipmentListViewState = {
  error                     : <string>'',
  loading                   : <boolean>false,
  MIDOrdersLoading          : <boolean>false,
  previousYellowBagModalView: <string>'',
  yellowBagsLoading         : <boolean>false,
  yellowBagModalView        : <string>''
}

const selectedShipmentState = {
  shipment: <Shipment>null
};

const initialRTSTotalState =  {
  RTS: <Shipment[]>[],
  jobs: <number>0,
  packages: <number>0,
  rtsAll: <number>0
};

export function RTSTotalReducer(state = initialRTSTotalState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case GET_RTS_TOTALS:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function packageFormListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_PACKAGE_FORM:
      return [ ...state, action.payload ];
    case UPDATE_PACKAGE_FORM:
      return state.map(pkg => {
        return pkg.shipmentID === action.payload.shipmentID
          ? Object.assign({}, pkg, action.payload)
          :    pkg;
      });
    default:
      return state;
  }
}

export function shipmentAmountsReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case GET_SHIPMENT_AMOUNTS:
      return [ ...action.payload.shipmentAmounts ];
    default:
      return state;
  }
}

export function shipmentDetailsViewReducer(state = initialShipmentDetailsViewState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialShipmentDetailsViewState);
    case SET_SHIPMENT_DETAILS_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function shipmentEstimatesListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_ESTIMATES:
      return [ ...state, action.payload ];
    case UPDATE_ESTIMATES:
      return state.map(estimate => {
        return estimate.shipmentID === action.payload.shipmentID
          ? Object.assign({}, estimate, action.payload)
          :    estimate;
      })
    default:
      return state;
  }
}

export function formattedShipmentsReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FORMATTED_SHIPMENTS:
      return [ ...action.payload.shipments ].sort(sortShipments);
    default:
      return state;
  }
}

export function selectedShipmentReducer(state = selectedShipmentState, action: Action) {
  switch (action.type) {
    case SET_SELECTED_SHIPMENT:
      return action.payload.shipment;
    default:
      return state;
  }
}

export function shipmentListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_SHIPMENT:
      const match = state.find(shipment => action.payload.shipment && shipment.id === action.payload.shipment.id);
      return !match
        ? [ ...state, action.payload.shipment ].sort(sortShipments)
        : state;
    case DELETE_ORDER:
      return state.filter(shipment => shipment.orderId !== action.payload.id);
    case DELETE_SHIPMENT:
      return state.filter(shipment => shipment.id !== action.payload.id);
    case GET_SHIPMENTS:
      return [ ...action.payload.shipments ].sort(sortShipments);
    case UPDATE_SHIPMENT:
      return state.map(shipment => {
        return shipment.id === action.payload.id
          ? objDiff(shipment, action.payload.diffList)
          : shipment;
      });
    default:
      return state;
  }
}

export function oaShipmentListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_OA_SHIPMENT:
      return [ ...state, action.payload.shipment ].sort(sortShipments);
    case DELETE_ORDER:
      return state.filter(shipment => shipment.orderId !== action.payload.id);
    case DELETE_OA_SHIPMENT:
      return state.filter(shipment => shipment.id !== action.payload.id);
    case GET_OA_SHIPMENTS:
      return [ ...action.payload.shipments ].sort(sortShipments);
    case UPDATE_OA_SHIPMENT:
      return state.map(shipment => {
        return shipment.id === action.payload.shipment.id
          ? action.payload.shipment
          : shipment;
      });
    case UPDATE_OA_SHIPMENTS:
      return state.map(stateShipment => {
        const match = action.payload.shipments.find(shipment => shipment.id === stateShipment.id);
        return !match ? stateShipment : match;
      });
    default:
      return state;
  }
}

export function shipmentListViewReducer(state = initialShipmentListViewState, action: Action) {
  switch (action.type) {
    case SET_SHIPMENT_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function formattedYellowBagsReducer(state = [], action: Action) {
  switch (action.type) {
    case GET_FORMATTED_YELLOWBAGS:
      return [ ...action.payload.yellowBags ];
    default:
      return state;
  }
}

export function yellowBagListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_YELLOWBAG:
      const match = state.find(yellowBag => action.payload.yellowBag && yellowBag.id === action.payload.yellowBag.id);
      return !match
        ? [ ...state, action.payload.yellowBag ]
        : state;
    case DELETE_YELLOWBAG:
      return state.filter(yellowBag => yellowBag.id !== action.payload.id);
    case GET_YELLOWBAGS:
      return action.payload.yellowBags;
    case UPDATE_YELLOWBAG:
      return state.map(yellowBag => {
        return yellowBag.id === action.payload.id
          ? objDiff(yellowBag, action.payload.diffList)
          : yellowBag;
      })
    default:
      return state;
  }
}

export function oaYellowBagListReducer(state = [], action: Action) {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_OA_YELLOWBAG:
      return [ ...state, action.payload.yellowBag ];
    case DELETE_OA_YELLOWBAG:
      return state.filter(yellowBag => yellowBag.id !== action.payload.id);
    case GET_YELLOWBAGS:
        console.log("GET YELLOW BAGS: ",action)
        return action.payload.yellowBags;
    case UPDATE_OA_YELLOWBAG:
      return state.map(yellowBag => {
        return yellowBag.id === action.payload.yellowBag.id
          ? action.payload.yellowBag
          : yellowBag;
      });
  }
}

function sortShipments(shipment1, shipment2): number {
  const date1 = new Date(shipment1.dueDate);
  const date2 = new Date(shipment2.dueDate);

  return +date1 - +date2;
}

export const shipmentReducers = combineReducers({
  packageForms         : packageFormListReducer,
  formattedShipments   : formattedShipmentsReducer,
  shipmentAmounts      : shipmentAmountsReducer,
  shipmentDetailsView  : shipmentDetailsViewReducer,
  shipmentEstimates    : shipmentEstimatesListReducer,
  shipmentList         : shipmentListReducer,
  oaShipmentList       : oaShipmentListReducer,
  RTSTotal             : RTSTotalReducer,
  shipmentListView     : shipmentListViewReducer,
  formattedYellowBags  : formattedYellowBagsReducer,
  yellowBagList        : yellowBagListReducer,
  oaYellowBagList      : oaYellowBagListReducer
});



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/reducers/shipments.ts